import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = process.env.REACT_APP_API_BASE_URL;

export const vehicleApi = async (vendor) => {
  let url = ""
  const page = vendor?.page === 0 || vendor?.page ? vendor?.page+1 : 1
  if(vendor?.id){
    url = `${env}${API_ENDPOINT.Vehicle.api+"?id="+vendor?.id+"&type="+vendor.type+"&status="+(vendor?.status?vendor?.status:'')+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')+"&search="+(vendor?.search?vendor?.search:'')}`
  }else if(vendor?.subVendorId){
    url = `${env}${API_ENDPOINT.Vehicle.api+"?id="+vendor?.subVendorId+"&type="+vendor.type+"&status="+(vendor?.status?vendor?.status:'')+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')+"&search="+(vendor?.search?vendor?.search:'')}`
  }else if(vendor?.driverId){
    url = `${env}${API_ENDPOINT.Vehicle.api+"?id="+vendor?.driverId+"&type="+vendor.type+"&status="+(vendor?.status?vendor?.status:'')+"&location="+(vendor?.location?vendor?.location:'')+"&dateFrom="+(vendor?.dateFrom?vendor?.dateFrom:'')+"&dateTo="+(vendor?.dateTo?vendor?.dateTo:'')+"&page="+page+"&pageSize="+(vendor?.pageSize?vendor?.pageSize:'')+"&search="+(vendor?.search?vendor?.search:'')}`
  }else if(vendor?.vehicleId){
    url = `${env}${API_ENDPOINT.Vehicle.api+"/"+vendor?.vehicleId}`
  }else{
    url = `${env}${API_ENDPOINT.Vehicle.api}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const addVehicleApi = async (data) => {
  let url = ""
 const UserId= data.get("id")
  
  if(UserId){
    url = `${env}${API_ENDPOINT.Vehicle.api+"/"+UserId}`
  }else{
    url = `${env}${API_ENDPOINT.Vehicle.api}`
  }
  const res = await requestInstance
    .post(url, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateVehicleApi = async (data) => {
  let id;
  let url = ''

  if (data instanceof FormData) {
    id = data.get("id");
  } else {
    id = data.id || data?.vehicleId;
  }

  if(data?.vehicleId){
    url = data?.data
  }else{
    url = data
  }

  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Vehicle.api+'/' + id}`, url)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const  deleteVehicleApi = async(data) => {

  let url = `${env}${API_ENDPOINT.Vehicle.api+"/"+data.vehicleId}`

  // if(data.carType = 'DOC'){
  //   url = `${env}${API_ENDPOINT.Vehicle.driverApi+"/"+data.vehicleId}`
  // }
  const res = await requestInstance.delete(
      url    
  )
  .catch((err) =>  err.response)
  return setCurrentUser(res)
}

export const matrixVehicleApi = async (data) => {
  let url = ""
  if(data?.vehicleId){
    url = `${env}${API_ENDPOINT.Vehicle.matrixApi+"?"+'vehicleId='+data.vehicleId}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const moreVehicleApi = async (data) => {
  let url = ""
  if(data?.submitterId){
    url = `${env}${API_ENDPOINT.Vehicle.moreApi+"?"+'submitterId='+data.submitterId+ '&submitterType='+data.submitterType}`
  }
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};